// Huelle fuer den Detailbereich (UX-Vorschlag P3), seit 2026-10-28 als
// Inlay: mittig ueber abgedunkelter Seite statt als Leiste rechts — wie in der
// Mac-App (juuplan #1252/#1254). Klick auf den dunklen Bereich schliesst; Esc
// und ↑/↓ behandelt das Panel selbst (TaskDetailPanel). Auf dem Telefon nimmt
// das Inlay den ganzen Bildschirm ein.
//
// Die Kartenoptik des Panels (Rahmen, Rundung, Hoehenbegrenzung) gilt nur in
// einer Spalte und wird hier per `*:` aufgehoben — die Huelle traegt sie.
// z-40: ueber der Kopfzeile (z-30), unter echten Dialogen (Modal, z-50), damit
// Rueckfragen aus dem Panel darueber erscheinen.

import { createPortal } from "preact/compat";
import { useEffect } from "preact/hooks";
import type { ComponentChildren } from "preact";

export function DetailSheet({
  children,
  onClose,
}: {
  children: ComponentChildren;
  onClose: () => void;
}): preact.JSX.Element {
  // Seite dahinter scrollt nicht mit.
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return createPortal(
    <div class="juuplan-overlay-in fixed inset-0 z-40 flex items-center justify-center sm:p-6">
      <div
        class="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
        data-testid="detail-sheet-backdrop"
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Aufgabendetails"
        class="relative h-full w-full overflow-y-auto bg-[color:var(--color-surface-container-lowest)] shadow-level-3 sm:h-auto sm:max-h-[calc(100dvh-3rem)] sm:max-w-[680px] sm:rounded-lg *:min-h-full sm:*:min-h-0 sm:border sm:border-[color:var(--color-outline-variant)] *:max-h-none *:overflow-visible *:rounded-none *:border-0"
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
